/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNodeLinksLink', [function () {
        return {
            replace: true,
            template: '<a ng-if="hasLinks()" \
              ng-class="{\'node-links-link\': true, expired: !hasActiveLinks()}" \
              href \
              title="{{\'View shared links\' | translate }}"\
              acc-link-details \
             >\
                <i class="icon-acc-share_link icon-3x"></i>\
            </a>',
            link: function ($scope) {
                $scope.hasLinks = function () {
                    return !$scope.node['is_directory'] && $scope.node['is_shared'];
                };

                $scope.hasActiveLinks = function () {
                    return $scope.node['has_active_links'];
                }
            }
        }

    }]);
